import React from "react";
import Seo from "./Seo";
import { formatPageTitle } from "../lib/seoUtils";

/**
 * SEO wrapper for private / transactional pages that should not be indexed.
 */
const NoIndexSeo = ({ title }) => (
  <Seo title={formatPageTitle(title)} noindex />
);

export default NoIndexSeo;
